<template>
    <!-- <div id="app">
        <ejs-grid :dataSource="data"> </ejs-grid>
    </div> -->
    <div id="app">
      <ejs-button id='print' @click.native='print'>Imprimir</ejs-button>
        <ejs-grid ref='grid' :dataSource="datap" :allowFiltering='false'  :allowPaging="true" :pageSettings='pageSettings'>
          <e-columns>
             <!-- <e-column headerText='' width='60' textAlign='Center' :template='cTemplate'></e-column> -->
            <e-column field='numtra' headerText='PEDIDO' textAlign='Ricenterght' width=90></e-column>
            <e-column field='fecfac' headerText='FECHA'  type='date' format='dd/MM/yyyy' width=80></e-column>
            <e-column field='totfac' headerText='TOTAL' textAlign='center' format='C2' width=90></e-column>
            <e-column headerText='DETALLE' width='70' textAlign='center' :template='bTemplate'></e-column>
          </e-columns>
        </ejs-grid>
    </div>
</template>

<script>
import Vue from "vue";
// import { GridPlugin } from "@syncfusion/ej2-vue-grids";
import { GridPlugin, Page, Filter, Toolbar  } from "@syncfusion/ej2-vue-grids";
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import axios from "axios";
import auth from '@/auth/authService'
import router from '../../../../src/router'
import {mapMutations, mapState, mapActions} from 'vuex'

Vue.use(GridPlugin);
Vue.use(ButtonPlugin);

export default {
  data () {
    return {
      pageSettings: { pageSizes: false, pageSize: 9 },
      datap: [],
      toolbarOptions: ['Print'],
      bTemplate: function () { 
          return { template : Vue.component('columnTemplate',{ 
             template: `<ejs-button cssClass='e-round' iconCss='e-icons e-plus-icon' isPrimary=true v-on:click.native="btnClick"></ejs-button>`, 
                data: function() { 
                    return { 
                        data: {} 
                    } 
                }, 
                methods: {
                  btnClick: function () { 
                    router.push(
                      {
                        name: 'page-invoice', params: {ped: this.data }
                      })
                  }, 
                }
          })} 
          } 
    }
  },
  computed: {
  ...mapState('eCommerce',['clientState', 'ruccedState', 'codempState', 'paramState', 'lispreState', 'desartState', 'descliState', 'orderState', 'historialPedidos']),
  },
  methods: {
    ...mapActions('eCommerce', ['getHistorialPedidos', 'getClient']),
    ...mapMutations('eCommerce', ['UPDATE_RUCCED', 'UPDATE_CODEMP', 'UPDATE_PARAMS', 'UPDATE_LISPRE', 'UPDATE_DESART', 'UPDATE_DESCLI']),
    setPedido(pedido){
      this.UPDATE_pedidoSeleccionado(pedido)
    },
    print: function() {
        this.$refs.grid.print();
    },
    getPedidos: async function() {
      var date = new Date(), y = date.getFullYear(), m = date.getMonth();
      var historyPayload = []
      historyPayload.codemp = this.codempState;
      historyPayload.codcli = this.clientState.codcli;
      historyPayload.firstDay = new Date(y, m, 1);
      historyPayload.lastDay = new Date(y, m + 1, 0);
      historyPayload.token = auth.getToken();
      this.getHistorialPedidos(historyPayload).then(
      response => { 
        this.datap = this.historialPedidos;
      })    
    },
    getClientDefaul(){
      this.UPDATE_RUCCED(localStorage.getItem("rucced"));
      this.UPDATE_CODEMP(localStorage.getItem("codemp"));
      this.UPDATE_PARAMS(JSON.parse(localStorage.getItem("parcli")));
      var payloadClients = [];
      payloadClients.rucced = this.ruccedState;
      payloadClients.codemp = this.codempState;
      payloadClients.token = auth.getToken();
      this.getClient(payloadClients).then(
        response => { 
          this.setParams(this.clientState, this.paramState)
          this.getPedidos()
        })
    },
    setParams(clients, params){
      if(params.ec_lispre == 'C'){ 
        this.UPDATE_LISPRE(clients.lispre ? clients.lispre : 1)
      }else{
        this.UPDATE_LISPRE(params.ec_lispre);
      }
      if(params.ec_desart == 'S'){
        this.UPDATE_DESART(this.lispreState)
      }else{
        this.UPDATE_DESART(0)
      }
      if(params.ec_descli == 'S'){
        this.UPDATE_DESCLI(clients.descu ? clients.descu : 1)
      }else{
        this.UPDATE_DESCLI(0)
      }
    },
  },
  created () {
    if(this.clientState.length == 0){
      this.getClientDefaul()
    }else{
      this.getPedidos()
    }
  },
  provide: {
    grid: [Page, Filter, Toolbar]
  }
}
</script>

<style>
  @import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
  @import "../../../../node_modules/@syncfusion/ej2-base/styles/material.css"; 
  @import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css"; 
  @import "../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css"; 
  @import "../../../../node_modules/@syncfusion/ej2-popups/styles/material.css"; 
  @import "../../../../node_modules/@syncfusion/ej2-vue-navigations/styles/material.css"; 
  @import "../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css"; 
  @import "../../../../node_modules/@syncfusion/ej2-lists/styles/material.css"; 
  @import "../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css"; 
  @import "../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css";
    .image img {
        height: 55px;
        width: 55px;
        border-radius: 50px;
        box-shadow: inset 0 0 1px #e0e0e0, inset 0 0 14px rgba(0,0,0,0.2);
    }

    button {
  margin: 5px 5px 20px 20px;
}

.e-plus-icon::before {
  content: '\e823';
}
</style>